import { NumberField } from "@/components/admin/number-field";
import { Show } from "@/components/admin/show";
import { SimpleShowLayout } from "@/components/admin/simple-show-layout";
import { TextField } from "@/components/admin/text-field";

export const ProductShow = () => (
  <Show title="Producto">
    <SimpleShowLayout>
      <TextField source="clase" label="Clase" />
      <TextField source="codigo" label="Código" />
      <TextField source="marca" label="Marca" />
      <TextField source="origen" label="Origen" />
      <TextField source="producto" label="Producto" />
      <TextField source="medida" label="Medida" />
      <TextField source="color" label="Color" />
      <TextField source="textura" label="Textura" />
      <TextField source="tendencia" label="Tendencia" />
      <TextField source="formato" label="Formato" />
      <NumberField source="precio" label="Precio" />
      <NumberField source="precio_iva" label="Precio + IVA" />
    </SimpleShowLayout>
  </Show>
);
